import React, { forwardRef, useImperativeHandle } from 'react';
import { Label, TextField, Text, Stack, Icon, DefaultButton, DetailsList, DetailsListLayoutMode, SelectionMode, Toggle } from '@fluentui/react';
import SingleFileDropzone from '../../Common/FileDropzone/SingleFileDropzone';
import { checkMaxSize } from '../WizardRegistroEntrenador';
import CustomInputIfc from '../../../lib/FormValidator/Form/CustomInputIfc';
import InputField from '../../../lib/FormValidator/Form/InputField';
import MessageCourier from '../../../lib/MessageCourier';
import SystemClient from '../../../system/SystemClient';
import RegistroEntrenadorForm from '../../RegistroEntrenador/RegistroEntrenadorForm';
import RegistroEntrenadorTituloForm from '../../RegistroEntrenadorTitulo/RegistroEntrenadorTituloForm';
import ToggleInput from '../../../lib/FormValidator/Form/ToggleInput';
import { useCustomInput } from '../../../common/custom-hooks/useCustomInput';
import useForceUpdate from '../../../common/custom-hooks/useForceUpdate';
import GridListIconFormat from '../../Common/GridListIconFormat';
import { formatFileSize, obtenerExtension } from '../WizardRegistroEntrenador';

interface ITituloSecundario {
  form: RegistroEntrenadorForm;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  system: SystemClient;
  courier: MessageCourier;
  nextStep: () => void;
  tituloSecundarioValido: boolean;
  setTituloSecundarioValido: (v: boolean) => void;
}

export const TituloSecundario = forwardRef(({ form, onBlurCustomInput, system, courier, nextStep, tituloSecundarioValido, setTituloSecundarioValido }: ITituloSecundario, ref) => {

  const [tituloForm, setTituloForm] = React.useState<RegistroEntrenadorTituloForm>(
    RegistroEntrenadorTituloForm.initialize()
  );

  const forceUpdate = useForceUpdate();
  const [formIsValid, setFormIsValid] = React.useState(false);

  const titulosList = useCustomInput(() => form.getTituloEntrenadorListInput(), [form]);
  const tituloInput = useCustomInput(() => tituloForm.getTituloInput(), [tituloForm]);
  const otorgadoPorInput = useCustomInput(() => tituloForm.getOtorgadoPorInput(), [tituloForm]);
  const docenteInput = useCustomInput(() => tituloForm.getDocenteInput(), [tituloForm]);
  const añoEgresoInput = useCustomInput(() => tituloForm.getAnioEgresoInput(), [tituloForm]);
  const tituloImagenInput = useCustomInput(() => tituloForm.getImagenTituloInput(), [tituloForm]);

  React.useEffect(() => {
    const tituloSecundario = titulosList.getValue().filter((titulo: any) => titulo.anioEgreso !== null);
    if (tituloSecundario.length > 0) {
      console.log('tituloSecundario: ', tituloSecundario[0]);
      console.log(RegistroEntrenadorTituloForm.with(tituloSecundario[0]));
      setTituloForm(RegistroEntrenadorTituloForm.with(tituloSecundario[0]));
    }
  }, [])

  React.useEffect(() => {
    const validForm = tituloForm.getTituloInput().getValue() && tituloForm.getOtorgadoPorInput().getValue() && tituloForm.getAnioEgresoInput().getValue();
    console.log(validForm);
    setTituloSecundarioValido(validForm);
  }, [tituloForm.getTituloInput().getValue(), tituloForm.getOtorgadoPorInput().getValue(), tituloForm.getAnioEgresoInput().getValue()])

  const onDropTitulo = (file: File) => {
    tituloImagenInput.setValue(file)
  }

  useImperativeHandle(ref, () => ({
    addTitulo: () => {
      const titulos = [...titulosList.getValue()];
      const tituloSecundario = titulos.filter((titulo: any) => titulo.anioEgreso !== null);
      if (tituloSecundario.length > 0) {
        const updatedTitulos = titulosList.getValue().map((titulo: any) => {
          if (titulo.anioEgreso !== null) {
            return tituloForm.toRegistroEntrenadorTitulo();
          }
          return titulo;
        });
        titulosList.setValue(updatedTitulos);
      } else {
        titulos.push(tituloForm.toRegistroEntrenadorTitulo());
        titulosList.setValue(titulos);
        setTituloForm(RegistroEntrenadorTituloForm.initialize());
        onBlurCustomInput(titulosList);
      }
      // nextStep();
    }
  }));

  const onBlurTitulos = (customInput: CustomInputIfc) => {
    if (tituloForm) {
      const isValid = tituloForm.getIdInput().getValue()
        ? !tituloForm.hasErrors()
        : tituloForm?.isValid();
      setFormIsValid(isValid);
      forceUpdate();
      return isValid;
    }
    return false;
  };

  // const columns = [
  //   {
  //     key: 'titulo',
  //     name: 'Titulo',
  //     fieldName: 'titulo',
  //     minWidth: 50,
  //     maxWidth: 90,
  //     isMultiline: true,
  //   },
  //   {
  //     key: 'otorgadoPor',
  //     name: 'Otorgado por',
  //     fieldName: 'otorgadoPor',
  //     minWidth: 50,
  //     maxWidth: 90,
  //     isMultiline: true,
  //   },
  //   {
  //     key: 'docente',
  //     name: 'Docente',
  //     fieldName: 'docente',
  //     minWidth: 50,
  //     maxWidth: 70,
  //     isMultiline: true,
  //     onRender: (item: any) => {return <GridListIconFormat formField={item.docente} width={50} />},
  //   },
  // ]

  const disableAdd = () => {
    return (!tituloForm.getTituloInput().getValue() || !tituloForm.getOtorgadoPorInput().getValue() || !tituloForm.getAnioEgresoInput().getValue()) || titulosList.getValue().filter((titulo: any) => titulo.anioEgreso !== null).length > 0;
  }

  return (
    <div>
      <div className="ms-Grid" dir="ltr">
        <Text
          className="mb-1"
          variant="small"
          styles={{ root: { textAlign: 'center', color: '#666', display: 'block' } }}
        >
          Secundario completo.
        </Text>

        <>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 form-item">
              <InputField input={tituloInput} label={'Titulo (*)'} onBlur={onBlurTitulos} />
            </div>
          </div>

          <div className="ms-Grid-row mt-2">
            <div className="ms-Grid-col ms-sm12 form-item">
              <InputField input={otorgadoPorInput} label={'Otorgado por (*)'} onBlur={onBlurTitulos} />
            </div>
          </div>

          <div className="ms-Grid-row mt-2">
            <div className="ms-Grid-col ms-sm6 form-item">
              <InputField
                input={añoEgresoInput}
                label={'Año de egreso (*)'}
                onBlur={onBlurTitulos}
                propsInput={{ type: 'number', inputMode: 'numeric' }}
              />
            </div>
            <div className="ms-Grid-col ms-sm6 form-item">
              <Stack horizontalAlign="center" className="text-center" style={{ marginTop: 28 }}>
                {' '}
                <SingleFileDropzone
                  label="Título"
                  icon="Camera"
                  onDrop={(file) => onDropTitulo(file)}
                ></SingleFileDropzone>
              </Stack>{' '}
              <div className="text-center">
                <Text variant="xSmall" className="" title="Formatos admitidos">
                  (JPG, JPEG, GIF, PNG, PDF)
                </Text>
              </div>
              {tituloForm.getImagenTituloInput().getValue() && (
                <div className="mt-2 text-center">
                  <Text block variant="medium" className="">
                    <Icon iconName="SkypeCircleCheck" style={{ color: '#107C10', marginRight: 10 }}></Icon>
                    Archivo {obtenerExtension(tituloForm.getImagenTituloInput().getValue().name)} cargado -{' '}
                    {formatFileSize(tituloForm.getImagenTituloInput().getValue().size)}
                  </Text>
                  {!checkMaxSize(tituloForm.getImagenTituloInput().getValue().size) && (
                    <Text block variant="medium" className="error-color">
                      El tamaño de la foto es demasiado grande, el maximo es de 20MB
                    </Text>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* <div className="ms-Grid-row mt-2">
          <div className="ms-Grid-col ms-sm6 form-item">
            <ToggleInput
              input={docenteInput}
              offText={'Otro título'}
              onText={'Es docente'}
              onBlur={onBlurTitulos}
            />
          </div>
        </div> */}

          {/* <div className="ms-Grid-row mt-2">
            <div className="ms-Grid-col ms-sm12 form-item">
              <DefaultButton
                disabled={disableAdd()}
                onClick={addTitulo}
                text="Agregar y avanzar"
                styles={{ root: { width: '100%' } }}
                primary
              />
            </div>
          </div> */}
        </>

        {/* {titulosList.getValue().map((titulo: RegistroEntrenadorTitulo, index: number) => ( */}
        {/* <div className="ms-Grid-row mt-2">
          <div className="ms-Grid-col ms-sm12 form-item">
            <DetailsList
              items={titulosList.getValue()}
              columns={columns}
              layoutMode={DetailsListLayoutMode.fixedColumns}
              selectionMode={SelectionMode.none}
            />
          </div>
        </div> */}
        {/* ))} */}
      </div>
    </div>
  );
});
